import ModalDeleteFilled from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'


interface ModalDeleteWorkingCenterBankProps extends ModalEditComponentProps { }

const ModalDeleteWorkingCenterBank: React.FC<ModalDeleteWorkingCenterBankProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()

    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/workingCenter/workingCenterBank/updateWorkingCenterBank',
        data: {
            id: allRowData?.id,
            active: !allRowData?.active
        }
    })
    let translations = {
        title: t('sureUnableWorkingCenterBank', '¿Seguro quieres desactivar este banco del centro de trabajo?'),
        subtitle: t('onceDeletedCouldBeRecovered', 'Una vez desactivado se podrá reactivar de nuevo'),
        buttonAccept: t('unable', 'Desactivar')
    }
    if (!allRowData?.active) {
        translations = {
            title: t('sureEnableWorkingCenterBank', '¿Seguro quieres activar este banco del centro de trabajo?'),
            subtitle: t('onceEnabledCouldBeDeletedF', 'Una vez activada se podrá desactivar de nuevo'),
            buttonAccept: t('enable', 'Activar')
        }
    }
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={translations} />
    )
}

export default ModalDeleteWorkingCenterBank